import React from 'react';
import {Box, Container, Flex, Heading, Highlight, Image,Text} from "@chakra-ui/react";
import servicesBanner from "../../assets/img/servicesBanner.webp";
import {servicesStaticData} from "../../helpers/adminData";
const Services = () => {
    return (
        <Box name="services" mt={{base:"130px",md:"70px"}} mb={{base:"212px",md:"50px"}}>
            <Container maxW="container.xl">
                <Flex alignItems="start" justifyContent="center" flexDir={{base:"column-reverse",lg:"row"}} pos="relative" w="full" h="668px" bg="#EEEEEE" borderRadius="20px" p={{base: "36px 10px", md: "69px 43px"}}>
                    <Box w={{base:"210.04px",md:"335.29px"}} m="0 auto" pos={{base:"absolute",lg:"static"}} bottom={{base:"-38%",sm:"-20%",md:"-10%",lg:"0"}} right="0">
                        <Image src={servicesBanner} alt=""/>
                    </Box>
                    <Box w={{base:"full",lg:"50%"}} m="0 0 auto">
                        <Heading pb={{base: "10px", lg: "4px"}} fontFamily='Raleway' fontWeight="700"
                                 fontSize={{base: "30px", lg: "54px"}} color={{base:"#1B1918",lg:"#111212"}}
                                 lineHeight={{base: "35px", lg: "63px"}}>
                            <Highlight query="услуги" styles={{color: "#E92F34"}}>Дополнительные услуги</Highlight>
                        </Heading>
                        {servicesStaticData.map(({icon,item}) => (
                            <Flex alignItems="start" mt={{base:"45.5px",lg:"40px"}} mb={{base:"41px",lg:"34px"}} fontFamily='Raleway' fontSize={{base:"18px",lg:"24px"}} fontWeight="600" color="#111212" lineHeight={{base:"21px",lg:"28px"}}>
                                {icon}
                                <Text ml="8px">{item.split('\n').map(el => (<Text>{el}</Text>))}</Text>
                            </Flex>
                        ))}
                    </Box>
                </Flex>
            </Container>
        </Box>
    );
};

export default Services;
